//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//On Sale (Semi-private) > Pre-order > Pre-release > Sold out > Limited > Web-exclusive > New
import { StatusMessageTypeE } from '@/scripts/libs/algolia/types/plp'
import { mapGetters } from 'vuex'

export default {
  name: 'product-tile-status-message',
  props: {
    message: {
      type: Object,
      default: () => {
        return {
          label: '',
          type: '',
        }
      },
    },
    isFlash: {
      type: Boolean,
      default: false,
    },
    isMemberAccess: {
      type: Boolean,
      default: false,
    },
    formattedRemainingTime: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      StatusMessageTypeE: StatusMessageTypeE,
    }
  },
  computed: {
    ...mapGetters(['userLoggedIn']),
    label() {
      return this.$t(this.message?.label)
    },
    type() {
      return this.message?.type
    },
  },
}
